import { createSelector } from '@reduxjs/toolkit';
import { includes } from 'lodash';

import optionGroupsModule from 'domains/option_groups';
import cartProducts from 'domains/cart_products';

// Order Options are limited by certain products
// If all cart products in a cart don't support an order option, filter it out of the list
export const availableOrderOptions = createSelector(
  [optionGroupsModule.selectors.allOrderOptions, cartProducts.selectors.unsupportedOrderOptions],
  (orderOptions, unsupportedUids) => {
    return orderOptions.filter(({ uid }) => {
      return !unsupportedUids.every((exclude) => includes(exclude, uid));
    });
  }
);
